import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripsDurationByDriverId } from '../../services/TripsService';
import { TripsDurationResponse } from '../../types/Trips';

function useGetTripsDurationByDriverId(fleetId: string, driverId: string): UseQueryResult<TripsDurationResponse> {
  return useQuery(
    ['trips-aggregation-duration', fleetId, driverId],
    async (): Promise<TripsDurationResponse> => getTripsDurationByDriverId(fleetId, driverId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetTripsDurationByDriverId;
